import { createFileRoute, redirect } from '@tanstack/react-router';

import { featureFlagsReady } from '@/features/feature-flags';
import { PluginScreen } from '@/plugins/plugin-screen';
import { pluginsStore } from '@/plugins/plugins.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/p/$pluginId')({
  staticData: { headerTitle: 'page' },
  async beforeLoad({ params }) {
    await featureFlagsReady();
    await pluginsStore.load(params.pluginId);
    if (pluginsStore.pageOf(params.pluginId)) return;
    throw redirect({ to: Routes.Chats as string, replace: true });
  },
  component: function PluginRoute() {
    const { pluginId } = Route.useParams();
    return <PluginScreen pluginId={pluginId} />;
  },
});
